import React, { useEffect, useState } from "react";
import {
  IconButton,
  InputAdornment,
  Modal,
  Tooltip,
  TextField,
  Button,
  Box,
  Alert,
  Typography
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Link } from "react-router-dom";
import { loginSchema } from "../../schema/authSchema";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { login } from "../../redux/apiCall";
import { useDispatch } from "react-redux";
import graphqlRequest from "../../requestMethod";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import PhoneEmailOtp from "../../components/PopUp/Otp/PhoneEmailOtp/PhoneEmailOtp";
import ForgetPassword from "../../components/PopUp/Otp/ForgetPassword/ForgetPassword";
import { message } from "../../components/Common/SnakeAlert/SnakeAlert";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import Google from "../../services/Google";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useRef } from "react";
import MobileViewPopUp from "../../components/PopUp/MobileViewPopUp/MobileViewPopUp";
import { signUpSuccess } from "../../redux/userReducer";
import eventHelpers from "../../Helpers/Event";
import "./LoginForm.css";
import { pushEvent, pushProfile } from "../../utils/clevertap";

const LoginForm = ({ onClose }) => {
  //   const [email, setEmail] = useState("");
  //   const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginMethod, setLoginMethod] = useState("password");

  const [Tabvalue, setTabValue] = React.useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isFatching } = useSelector((state) => state);
  const [isOtpModelOpen, setOtpModelOpen] = useState(false);
  const [userInput, setUserInput] = useState(null);
  const [token, setToken] = useState("");
  const [forgetModel, setForgetModel] = useState(false);
  const [forgetEmailOrPassword, setForgetEmailOrPassword] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [forgetPasswordToken, setForgetPasswordToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [successForgetToken, setSuccessForgetToken] = useState("");
  //   const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showMobilePopUp, setShowMobilePopUp] = useState(false);

  let [emailError, setEmailError] = useState({
    test: "",
  });
  let [logincred, setLoginCred] = useState({
    email: "",
    password: "",
  });
  let [otpCred, setOtpCred] = useState({
    emailPhone: "",
  });
  let [otpCredError, setOTPCredError] = useState({
    emailPhone: "",
  });
  let [loginCredError, setLoginCredError] = useState({
    test: "",
  });
  let [passwordChange, setPasswordChange] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  let [passwordChangeError, setPasswordChangeError] = useState({
    test: "",
  });

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleClickShowPassword2 = () => {
    setShowPassword2(!showPassword2);
  };
  const {
    getValues,
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(loginSchema),
  });

  let fetchUserDetails = (accessToken) => {

    const query = `
      query {
        withAuth(token: "${accessToken}") {
          userDetails {
            id
               profile {
          organization {
            name
            role
            website
          }
				}
            name {
              full
            }
            emails {
              address
            }
            phoneNumbers {
              number
            }
          }
        }
      }
    `;
  
    graphqlRequest(query).then((response) => {
  
      const user = response?.data?.withAuth?.userDetails;
  
      if (!user) return;
  
      // 🔥 Identify user in CleverTap
      pushProfile({
        id: user?.id,
        name: user?.name?.full,
        email: user?.emails[0]?.address,
        phone: user?.phoneNumbers[0]?.number,
        company: user?.profile?.organization?.name,
        role:  user?.profile?.organization?.role
      });
      // initCleverTapPush();
      // 🔥 Fire Login Event
      pushEvent("Web_User_LoggedIn", {
        method: "Email",
        userType: "User",
      });
      pushEvent("Web_Dashboard", {
        page: "Home",
        section: "Dashboard",
      });
    });
  };

  const handleLoginSubmit = async (data, e) => {
    e.preventDefault();
    const response = await login(dispatch, data);
    console.log("login Response-->", response);
    if (response?.data?.loginV1) {
      if (response?.data?.loginV1?.isAdmin === true) {
        // console.log("Storing token in localStorage:", response.data.login.accessToken);
        navigate("/admin/login");
        localStorage.setItem("adminToken", response.data.loginV1.accessToken);
      } else if (
        response?.data?.loginV1?.verifyToken &&
        response.data?.loginV1?.accessToken == null
      ) {
        navigate("/login/setpassword");
        localStorage.setItem(
          "SetVerifyToken",
          response.data.loginV1.verifyToken
        );
      } else {
        // navigate("/");
        fetchUserDetails(response?.data?.loginV1?.accessToken);
        const params = new URLSearchParams(window.location.search);
        const redirectPath = params.get("redirect") || "/";
        navigate(redirectPath);
        message.success("Login Successful!");
      }
    }else if(response.errors[0].message === "Hospital not enabled!"){
      message.error("Hospital not setup. Please send email to support@jobizo.com");
    }
    //  else if (screenSize.width < 767 && response?.data?.loginV1) {
    //   setShowMobilePopUp(true);
    //   openBlitzllamaSurvey();
    // }
    else {
      message.error("Email or Password is incorrect");
    }
  };

  const inputRef = useRef(null);

  function loginWithOtp() {
    const query = `
    query {
      loginWithOtp(emailOrPhone:"${userInput}",isWeb:true)
    } 
  `;

    graphqlRequest(query).then((response) => {
      if (response?.errors?.[0]?.message === "Check your credentials!") {
        message.error("Email/Phone number is not registered with us!");
      } else {
        console.log(response);
        setToken(response?.data?.loginWithOtp);
        setOtpModelOpen(true);
        message.success("OTP has been sent.");
      }
    });
  }
  function loginWithForgetOtp() {
    const query = `
    query {
      forgotPasswordHospital(email:"${forgetEmailOrPassword}")
    } 
  `;
    graphqlRequest(query).then((response) => {
      if (response?.data?.forgotPasswordHospital) {
        setForgetPasswordToken(response?.data?.forgotPasswordHospital);
        message.success("OTP Sent Successfully ");
        setForgetModel(true);
      } else {
        message.error("Email is not registered with us!");
        // console.log("Forgetresponse",response)
        // alert("Check your credentials!")
        // setToken(response.data.loginWithOtp)
      }
    });
  }
  function handleResendForgetOtp() {
    const query = `
    query {
      forgotPasswordHospital(email:"${forgetEmailOrPassword}")
    } `;
    graphqlRequest(query).then((response) => {
      setForgetPasswordToken(response?.data?.forgotPasswordHospital);
    });
  }
  function handleResendOtp() {
    const query = `
    query {
      loginWithOtp(emailOrPhone:"${userInput}",isWeb:true,resend:true)
    }
  `;

    graphqlRequest(query).then((response) => {
      setToken(response.data.loginWithOtp);
    });
  }
  let handleOtpVerification = () => {
    loginWithOtp();
  };
  let handleForgetModel = () => {
    setForgetModel(!forgetModel);
  };
  function validatemyEmail() {
    let error = {};
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!forgetEmailOrPassword) {
      error.email = "please provide you mail id ";
    }
    if (!regex.test(forgetEmailOrPassword)) {
      error.email = "Invalid Mail Id ";
    }
    return error;
  }
  useEffect(() => {
    setEmailError(validatemyEmail);
  }, [forgetEmailOrPassword]);

  let handleForgetPassword = () => {
    loginWithForgetOtp();
  };
  const handleNewPAssword = () => {
    const query = `mutation {
      resetPassword(
          resetToken: "${successForgetToken}",
          password: "${passwordChange?.newPassword}"
      )
    }`;
    graphqlRequest(query).then((response) => {
      if (response) {
        message.success("Password Reset Successfully");
        setTabValue(0);
        setLoginMethod("password"); // Switch back to password login
      } else {
        message.error("Someting Went Wrong");
      }
    });
  };

  function validateLoginError() {
    let error = {};
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!logincred.email) {
      error.email = "Please provide you email";
    }
    if (!regex.test(logincred.email)) {
      error.email = "Please enter valid Email";
    }
    if (!logincred.password) {
      error.password = "Please provide your password";
    }
    if (!logincred.password) {
      error.password = "Please provide your password";
    }
    if (logincred?.password?.length == 0) {
      error.password = "Password Field cannot be blank";
    }
    if (
      logincred?.password?.length > 0 &&
      (logincred?.password?.length < 8 || logincred?.password?.length > 16)
    ) {
      error.password = "Please enter valid Password";
    }
    return error;
  }
  function validateChangePassword() {
    const regex =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*()_+={}|[\]\\:;\"\'<>,./?-]).{8,16}$/;
    let error = {};
    if (passwordChange.newPassword !== passwordChange.confirmPassword) {
      error.password = "Password Missmatch";
    }
    if (!regex.test(passwordChange.newPassword)) {
      error.password = "Invalid Password";
    }

    return error;
  }
  function validateOTPError() {
    let error = {};

    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex = /^(\+91-|\+91|0)?\d{10}$/;
    // let isValidEmail = emailRegex.test(value);
    // let isValidPhone = phoneRegex.test(value);

    // if (!isValidEmail && !isValidPhone) {
    //   return false;
    // }
    // if (isValidEmail) {
    //   return "emailAddress";
    // }
    // if (isValidPhone) return "number";

    let isValidEmail = emailRegex.test(userInput);
    let isValidPhone = phoneRegex.test(userInput);
    if (!userInput) {
      console.log("11111");
      error.emailPhone = "Email or Mobile Number Field cannot be Blank";
    } else if (!isValidEmail && !isValidPhone) {
      error.emailPhone = "Please enter Valid Email or Mobile Number";
    }
    // if (isValidEmail) {
    //   return "emailAddress";
    // }
    // if (isValidPhone) return "number";
    // if (!emailRegex.test(userInput) || !phoneRegex.test(userInput)) {
    //   console.log("22222");
    //   error.emailPhone = "invalid email/phone";
    // }
    // if (!phoneRegex.test(userInput)) {
    //   console.log("33333");
    //   error.emailPhone = "invalid phone";
    // }
    return error;
  }
  useEffect(() => {
    setLoginCredError(validateLoginError());
  }, [logincred]);
  useEffect(() => {
    setOTPCredError(validateOTPError());
  }, [userInput]);
  useEffect(() => {
    setPasswordChangeError(validateChangePassword());
  }, [passwordChange]);

  useEffect(() => {
    setTimeout(() => {
      // document.getElementById("header").click();
      inputRef.current.focus();
      // console.log("clicked", document.getElementById("header"));
    }, "3000");
  }, []);

  useEffect(() => {
    dispatch(signUpSuccess());
  }, [window.location.pathname]);

  const pressEnter = (e) => {
    if (e.keyCode == 13) {
      handleLoginSubmit(logincred, e);
    }
  };
  const pressEnterOTP = (e) => {
    if (e.keyCode == 13) {
      handleOtpVerification(userInput, e);
    }
  };

  //   const pressEnter = (e) => {
  //     if (e.key === 'Enter') {
  //         handleLoginSubmit(logincred, e);
  //     }
  //   };

  // console.log(email)
  // console.log(password)
  // const isFormValid = email && password;
  console.log("loginMethod>>",loginMethod)

  return (
    <>
   <div className="login-modal" onClick={onClose}>
  <div
    className="login-card"
    onClick={(e) => e.stopPropagation()}
  >
   
    <h2 className="title">Get Started</h2>

    <div className="login-tabs">
  <div
    className={`tab ${loginMethod === "password" ? "active" : ""}`}
    onClick={() => setLoginMethod("password")}
  >
    LOGIN WITH PASSWORD
  </div>

  <div
    className={`tab ${loginMethod === "otp" ? "active" : ""}`}
    onClick={() => setLoginMethod("otp")}
  >
   LOGIN WITH <br /> OTP
  </div>
</div>

    <form>
      {loginMethod === "password" ? (
        <>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email address"
              onChange={(e) =>
                setLoginCred({ ...logincred, email: e.target.value })
              }
            />
          </div>

          <div className="input-group password">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              onChange={(e) =>
                setLoginCred({ ...logincred, password: e.target.value })
              }
            />
            <span onClick={handleClickShowPassword}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </span>
          </div>

          <div className="row">
            <span
              className="forgot"
              onClick={() => setLoginMethod("forgot")}
            >
              Forgot Password?
            </span>
          </div>
        </>
      ) : loginMethod === "forgot" ? (
        <div>
              <div className="form-group">
                <span>
                  Please enter your registered email ID to reset Password.
                </span>
                <input
                  label="Verify Email"
                  fullWidth
                  autoComplete="off"
                  id="emailPhone"
                  placeholder="Verify Email"
                  type="text"
                  required
                  onBlur={() => {
                    if (emailError.email) {
                      message.error(emailError.email);
                    }
                  }}
                  onChange={(e) => setForgetEmailOrPassword(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      if (Object.keys(emailError).length === 0) {
                        handleForgetPassword();
                      }
                    }
                  }}
                />
                <div
                  className="input-otp-fields"
                  style={{ display: "flex", gap: "20px", marginTop: "20px" }}
                >
                  <Button
                    variant="contained"
                    style={{ marginLeft: "20px", width: "40%"  , backgroundColor:'red'}}
                    onClick={() => setLoginMethod("password")}
                  >
                    Cancel
                  </Button>

                  <Button
  variant="contained"
  style={{
    width: "40%",
    backgroundColor: Object.keys(emailError).length !== 0 ? "#c0c0c0" : "#3c59a5",
    color: Object.keys(emailError).length !== 0 ? "#6b6b6b" : "white"
  }}
  onClick={handleForgetPassword}
  disabled={Object.keys(emailError).length !== 0}
>
  Submit
</Button>
                </div>
              </div>
            </div>
          ) : loginMethod === "setnewpassword" ? (
            <Box sx={{ mb: 3 }}>
                  <Alert 
                    severity="info" 
                    sx={{ 
                      mb: 3,
                      "& .MuiAlert-message": { fontWeight: 500 }
                    }}
                  >
                    Your password must be 8-16 characters long and include at least one uppercase letter, one lowercase letter, one special character, and one number.
                  </Alert>
                  
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
                      Create New Password <span style={{ color: "#ef4444" }}>*</span>
                    </Typography>
                    <TextField
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      placeholder="Enter New Password"
                      value={passwordChange.newPassword}
                      onChange={(e) =>
                        setPasswordChange({
                          ...passwordChange,
                          newPassword: e.target.value,
                        })
                      }
                      onBlur={() => {
                        if (passwordChangeError.password) {
                          message.error(passwordChangeError.password);
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowPassword(!showPassword)}>
                              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          backgroundColor: "#f9fafb"
                        }
                      }}
                    />
                    
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#374151" }}>
                      Re-Enter New Password <span style={{ color: "#ef4444" }}>*</span>
                    </Typography>
                    <TextField
                      type={showPassword2 ? "text" : "password"}
                      fullWidth
                      placeholder="Re-Enter New Password"
                      value={passwordChange.confirmPassword}
                      onChange={(e) =>
                        setPasswordChange({
                          ...passwordChange,
                          confirmPassword: e.target.value,
                        })
                      }
                      onBlur={() => {
                        if (passwordChangeError.password) {
                          message.error(passwordChangeError.password);
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowPassword2(!showPassword2)}>
                              {showPassword2 ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          backgroundColor: "#f9fafb"
                        }
                      }}
                    />
                    {passwordChangeError.password && (
                      <Typography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                        {passwordChangeError.password}
                      </Typography>
                    )}
                  </Box>

                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleNewPAssword}
                    disabled={Object.keys(passwordChangeError).length !== 0}
                    sx={{
                      borderRadius: 2,
                      py: 1.5,
                      textTransform: "none",
                      fontWeight: 600,
                      backgroundColor: "#2D5FA1",
                      "&:hover": { backgroundColor: "#1e4a8c" },
                      "&:disabled": { backgroundColor: "#93c5fd", color: "#ffffff" }
                    }}
                  >
                    Set Password
                  </Button>
                </Box>
      ) : (
        <div className="input-group">
          <input
            type="text"
            placeholder="Email or Phone"
            onChange={(e) => setUserInput(e.target.value)}
          />
        </div>
      )}

      {loginMethod !== "forgot" && loginMethod !== "setnewpassword" && (
        <button
          className="primary-btn"
          onClick={(e) =>
            loginMethod === "password"
              ? handleLoginSubmit(logincred, e)
              : ( e.preventDefault(),
              handleOtpVerification(userInput, e))
          }
        >
          {isFatching ? <CircularProgress size={20} /> : "Continue"}
        </button>
      )}

      <div className="divider">OR</div>

      <div className="google-btn">
          <GoogleOAuthProvider clientId="1010923642758-7j3ub289s55cphbel85vtnkov74vhjjq.apps.googleusercontent.com">
                  <Google dispatch={dispatch} navigate={navigate} />
                </GoogleOAuthProvider>
      </div>
    </form>
  </div>
</div>
      <Modal
        open={isOtpModelOpen}
        onClose={setOtpModelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <PhoneEmailOtp
          openOtpHandler={isOtpModelOpen}
          setOpenOtpHandler={setOtpModelOpen}
          verifyMode="Email id"
          token={token}
          handleResendOtp={handleResendOtp}
          userInput={userInput}
        />
      </Modal>
      <Modal
        open={forgetModel}
        onClose={handleForgetModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ForgetPassword
          setSuccessForgetToken={setSuccessForgetToken}
          forgetPasswordToken={forgetPasswordToken}
          setTabValue={setTabValue}
          setLoginMethod={setLoginMethod}
          loginMethod={loginMethod}
          forgetModel={forgetModel}
          setForgetModel={setForgetModel}
          handleResendForgetOtp={handleResendForgetOtp}
          forgetEmailOrPassword={forgetEmailOrPassword}
        />
      </Modal>
      <Modal
        open={showMobilePopUp}
        onClose={setShowMobilePopUp}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MobileViewPopUp
          openOtpHandler={showMobilePopUp}
          setOpenOtpHandler={setShowMobilePopUp}
        />
      </Modal>
    </>
  );
};

export default LoginForm;
